// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p-datatable-thead th:nth-child(2) {
    width: 60% !important;
  }


  .custom-hover-button:hover {
    background-color:rgb(222, 222, 222) !important;
    border-color: rgb(204, 204, 204) !important;
  }`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
